import { render } from "./PortfolioProjetoDetalheAuditor.vue?vue&type=template&id=f0d5dde4&scoped=true"
import script from "./PortfolioProjetoDetalheAuditor.vue?vue&type=script&lang=js"
export * from "./PortfolioProjetoDetalheAuditor.vue?vue&type=script&lang=js"

import "./PortfolioProjetoDetalheAuditor.vue?vue&type=style&index=0&id=f0d5dde4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0d5dde4"]])

export default __exports__